import { useAppConfig } from '../../../hooks/use-app-config';
import { useCheckout } from '../../../hooks/use-checkout';
import { shouldUseTaxZipCodeForCountry } from '../../../utils/should-use-tax-zip-code-for-country';

export function useShowTaxCalculationFields() {
  const { featureFlags } = useAppConfig();
  const { checkoutData } = useCheckout();

  const isSupportedCountry = shouldUseTaxZipCodeForCountry(
    checkoutData?.customer.taxCountry || checkoutData?.customer.geoLocator.countryCode2
  );

  const showZipCodeField = isSupportedCountry && !featureFlags?.feature_collect_address_for_tax;

  const showAddressField = isSupportedCountry && featureFlags?.feature_collect_address_for_tax;
  return {
    showZipCodeField,
    showAddressField,
    useTaxCalculationField: showAddressField || showZipCodeField,
  };
}
